"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATE = exports.LOAD_CURRENT = exports.LOADING = exports.ERROR_LIST = exports.ERROR_HINT = exports.CURRENT_STEP = void 0;
exports.loadCurrent = loadCurrent;
exports.meterReadError = meterReadError;
exports.paginate = paginate;
exports.setCurrentStep = setCurrentStep;
exports.setLoadingStatus = setLoadingStatus;
var _meterReadingApi = require("../../api/meterReadingApi");
var LOAD_CURRENT = exports.LOAD_CURRENT = 'api/reducer/METER_READ';
var LOADING = exports.LOADING = 'api/reducer/METER_READ/LOADING';
var PAGINATE = exports.PAGINATE = 'reducer/METER_READ/PAGINATE';
var CURRENT_STEP = exports.CURRENT_STEP = 'reducer/METER_READ/CURRENT_STEP';
var ERROR_LIST = exports.ERROR_LIST = 'reducer/METER_READ/ERROR_LIST';
var ERROR_HINT = exports.ERROR_HINT = 'reducer/METER_READ/ERROR_HINT';
function loadCurrent(dispatch, currentPage) {
  dispatch({
    type: LOADING,
    data: {
      loading: true
    }
  });
  (0, _meterReadingApi.getMeterReadingData)().then(function (response) {
    dispatch({
      type: LOAD_CURRENT,
      data: {
        devices: response.data.content,
        currentPageId: currentPage
      }
    });
    dispatch({
      type: LOADING,
      data: {
        loading: false
      }
    });
  }).catch(function (error) {
    dispatch({
      type: ERROR_HINT,
      data: {
        code: error.response.data.errors[0].code,
        args: error.response.data.errors[0].args
      }
    });
    dispatch({
      type: LOADING,
      data: {
        loading: false
      }
    });
  });
}
function setLoadingStatus(dispatch, loading) {
  dispatch({
    type: LOADING,
    data: {
      loading: loading
    }
  });
}
function paginate(dispatch, currentPage) {
  dispatch({
    type: PAGINATE,
    data: {
      currentPageId: currentPage
    }
  });
}
function setCurrentStep(dispatch, step) {
  dispatch({
    type: CURRENT_STEP,
    data: {
      currentStep: step
    }
  });
}
function meterReadError(dispatch, errorObjects) {
  dispatch({
    type: ERROR_LIST,
    data: {
      errorObjects: errorObjects
    }
  });
}